import { put, call, take, fork } from 'redux-saga/effects'
import generalSaga from '../general'
import { SCORM_TRACK } from '../../reducers/scorm/type'
import { scormTrackService } from '../../api/scorm'
import { scormTrackSuccess, scormTrackError } from '../../reducers/scorm/action'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

function* scormTrackFlow(payload) {
  try {
    const { data, callback } = payload

    const response = yield call(scormTrackService, data)

    yield put(scormTrackSuccess(response.data))
    yield put(operationSuccess())

    if (callback) callback(response.data)
  } catch (error) {
    yield put(scormTrackError())
    yield put(operationFail(error))
  }
}

export default function* scormTrackWatcher() {
  while (true) {
    const action = yield take(SCORM_TRACK)
    const { payload } = action

    yield fork(generalSaga, scormTrackFlow, payload)
  }
}
